import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { List,InfiniteLoader,AutoSizer } from 'react-virtualized';

let remoteRowCount=10;
// List data as an array of strings
let   list = [];
function rowRenderer ({
  key,         // Unique key within array of rows
  index,       // Index of row within collection
  isScrolling, // The List is currently being scrolled
  isVisible,   // This row is visible within the List (eg it is not an overscanned row)
  style        // Style object to be applied to row (to position it)
}) {
  return (
    <div
      key={key}
      style={style}
    >
      {list[index]}
    </div>
  )
}



function isRowLoaded ({ index }) {
  console.log("zzzzzzz",index)
  return !!list[index];
}

function loadMoreRows ({ startIndex, stopIndex }) {
  console.log("zzz",startIndex, stopIndex)
  list = [
    'Brian Vaughn','Brian Vaughn','Brian Vaughn','Brian Vaughn','Brian Vaughn','Brian Vaughn','Brian Vaughn','Brian Vaughn',
    'Brian Vaughn','Brian Vaughn','Brian Vaughn','Brian Vaughn','Brian Vaughn','Brian Vaughn','Brian Vaughn','Brian Vaughn',
    'Brian Vaughn','Brian Vaughn','Brian Vaughn','Brian Vaughn','Brian Vaughn','Brian Vaughn','Brian Vaughn','Brian Vaughn',
    'Brian Vaughn','Brian Vaughn','Brian Vaughn','Brian Vaughn','Brian Vaughn','Brian Vaughn','Brian Vaughn','Brian Vaughn',
    'Brian Vaughn','Brian Vaughn','Brian Vaughn','Brian Vaughn','Brian Vaughn','Brian Vaughn','Brian Vaughn','Brian Vaughn',
    'Brian Vaughn','Brian Vaughn','Brian Vaughn','Brian Vaughn','Brian Vaughn','Brian Vaughn','Brian Vaughn','Brian Vaughn',
    'Brian Vaughn','Brian Vaughn','Brian Vaughn','Brian Vaughn','Brian Vaughn','Brian Vaughn','Brian Vaughn','Brian Vaughn',
    // And so on...
  ];
  return list;
  // return fetch(`path/to/api?startIndex=${startIndex}&stopIndex=${stopIndex}`)
  //   .then(response => {
  //     // Store response data in list...
  //   })
}

export  class Toto extends Component {
// Render your list
componentDidMount(){
  for(let i=0;i<5000;i++){
    list.push(i+": aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa")
  }
}
render(){
    return(
      <InfiniteLoader
      isRowLoaded={isRowLoaded}
      loadMoreRows={loadMoreRows}
      rowCount={remoteRowCount}
    >
      {({ onRowsRendered, registerChild }) => (
        <AutoSizer disableHeight>
        {({width}) => (
        <List
            // width={300}
            // height={200}
            // rowCount={list.length}
            // rowHeight={20}
            // rowRenderer={rowRenderer}

            height={200}
            onRowsRendered={onRowsRendered}
            ref={registerChild}
            rowCount={list.length}
            rowHeight={30}
            rowRenderer={rowRenderer}
            width={width}
        />
      )}
      </AutoSizer>
      )}
      </InfiniteLoader>
       
    )
}
   


}



// WEBPACK FOOTER //
// ./src/app/view/components/Monitor/TrackingCradList/toto.js